// main tools
import { useContext } from 'react';

// context
import { RouterContext } from '../context';

const useRouterContext = () => useContext(RouterContext);

export default useRouterContext;
